export default function SectionTitle({ children }: any) {
  return <h3 className="text-2xl text-blue-one my-10 font-bold">{children}</h3>;
}
